import React, { useEffect, useState } from 'react';
import './style.css';

declare global {
    interface Window {
        CLIENT_INTEGRATED: boolean;
        Econ: any;
        PopUp2: any;
        firebird: any;
        refetch: Function;
        refetchRest: Function;
        invalidate: Function;
        undockedInbox2: Window | null;

        /**
         * In case you need to use Econ or PopUp2 and Firebird is late, this allows you to wait for it.
         *
         * @example
         * window.top.firebirdTask.then(() => {} )
         * @example
         * await window.top.firebirdTask
         *
         * @memberof Window
         */
        firebirdTask: Promise<void>;
    }
}

export function useFirebird() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        let mounted = true;
        window.top.firebirdTask.then(() => {
            if (mounted) {
                setShow(true);
            }
        });

        return () => {
            mounted = false;
        };
    }, []);

    return {
        show,
    };
}

let firebirdReadyResolver: ((value?: void | PromiseLike<void> | undefined) => void) | undefined = undefined;

window.firebirdTask = new Promise((resolve, _) => {
    firebirdReadyResolver = resolve;
});

export default class Firebird extends React.Component {
    componentDidMount() {
        // provides firebird with a reliable integration point for branching
        window.top.CLIENT_INTEGRATED = true;

        window.top.addEventListener('firebird:ready', () => {
            // setup integration with firebird - this simplifies inconsistent access of the global Econ in firebird
            window.top.Econ = window.firebird.Econ;
            window.top.PopUp2 = window.firebird.PopUp2;
            // subnav isn't loaded anymore, so handle the event handlers it contained
            window.top.Econ.on('entrycounter.updatesingledaybook', () => window.top.refetch('/journals/totals/draft'));
            window.top.Econ.on('errorstatus.updatesent', () => window.top.refetch('/sales/invoicing/sent/errors'));

            if (firebirdReadyResolver) {
                firebirdReadyResolver();
            }
        });
    }

    render() {
        let inAppInstrumentation = '';

        if (window.location.search && window.location.search.toLowerCase().includes('inappinstrumentation')) {
            inAppInstrumentation = '?InAppInstrumentation=true';
        }

        return (
            <iframe
                name="firebird"
                src={`${process.env.REACT_APP_ECONOMIC_PATH}/default.aspx${inAppInstrumentation}`}
                title="legacy"
            />
        );
    }
}
